import api from './api';

const userService = {
  async getCurrentUser() {
    const response = await api.get('/api/auth/me');
    return response.data;
  },

  async updateProfile(userData) {
    const response = await api.put('/api/profile/me', userData);
    return response.data;
  },

  async getUserProfile(id) {
    const response = await api.get(`/api/users/${id}/profile`);
    return response.data;
  },

  async getUserParticipatedThreads(id, page = 1, limit = 15) {
    const response = await api.get(`/api/users/${id}/participated-threads`, {
      params: { page, limit },
    });
    return response.data;
  },

  async getUserRecentPosts(id, page = 1, limit = 15) {
    const response = await api.get(`/api/users/${id}/recent-posts`, {
      params: { page, limit },
    });
    return response.data;
  },

  async getPlayersList(page = 1, limit = 24, search = '', universe = '', presence = 'with') {
    const response = await api.get('/api/players', {
      params: {
        page,
        limit,
        ...(search.trim() ? { search: search.trim() } : {}),
        ...(universe ? { universe, presence: presence || 'with' } : {}),
      },
    });
    return response.data;
  },
};

export default userService;

